import { useTranslation } from "react-i18next";
import { useSettings } from "context/SettingsContext";

const CounterLabel = ({ showPrice }: { showPrice: boolean }) => {
    const { t } = useTranslation(['Warehouses']);
    const { localSettings } = useSettings();
    const isUahMode = (Number(localSettings?.RATE?.current ?? 1) || 1) === 1;

    return (
        <label className="form-label text-muted d-flex justify-content-between w-100">
            <span>{t('labelCount')}</span>
            <div>
                <span
                    className="fs-10 d-inline-block text-end pe-1 text-primary"
                    style={{ minWidth: '55px' }}
                >
                    {t('labelMax')}
                </span>
                {showPrice && (
                    <>
                        <span
                            className="fs-10 d-inline-block text-end pe-1 text-primary"
                            style={{ minWidth: '120px' }}
                        >
                            {t('labelPrice')}
                        </span>
                        {!isUahMode && (
                            <span
                                className="fs-10 d-inline-block text-end pe-2 text-primary"
                                style={{ minWidth: '55px' }}
                            >
                                {t('labelRate')}
                            </span>
                        )}
                    </>
                )}
            </div>
        </label>
    );
};

export default CounterLabel;
